// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteAdmin-FormDefinitionConfig-FormDefinitionModeHeader-module-formDefinitionModeHeaderBackground {
	border-bottom: var(--StandardBorder);
	-webkit-transition: background-color 0.25s linear;
	transition: background-color 0.25s linear;
}

.SiteAdmin-FormDefinitionConfig-FormDefinitionModeHeader-module-formDefinitionModeHeaderBackgroundWhite {
	background-color: var(--PrimaryWhite);
}

.SiteAdmin-FormDefinitionConfig-FormDefinitionModeHeader-module-formDefinitionModeHeaderZindex {
	z-index: 4;
}`, "",{"version":3,"sources":["webpack://./src/SiteAdmin/FormDefinitionConfig/FormDefinitionModeHeader.module.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC,iDAAyC;CAAzC,yCAAyC;AAC1C;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,UAAU;AACX","sourcesContent":[".formDefinitionModeHeaderBackground {\n\tborder-bottom: var(--StandardBorder);\n\ttransition: background-color 0.25s linear;\n}\n\n.formDefinitionModeHeaderBackgroundWhite {\n\tbackground-color: var(--PrimaryWhite);\n}\n\n.formDefinitionModeHeaderZindex {\n\tz-index: 4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formDefinitionModeHeaderBackground": `SiteAdmin-FormDefinitionConfig-FormDefinitionModeHeader-module-formDefinitionModeHeaderBackground`,
	"formDefinitionModeHeaderBackgroundWhite": `SiteAdmin-FormDefinitionConfig-FormDefinitionModeHeader-module-formDefinitionModeHeaderBackgroundWhite`,
	"formDefinitionModeHeaderZindex": `SiteAdmin-FormDefinitionConfig-FormDefinitionModeHeader-module-formDefinitionModeHeaderZindex`
};
module.exports = ___CSS_LOADER_EXPORT___;
